import toast from 'react-hot-toast';
import { axiosClearWishlist, axiosSetWishlist } from "../utilities/axioscall";
import { duration } from 'moment';

// Define Product interface to support both MyWishlist and ProductInfocartView
interface Product {
  id: string | number; // Changed to support string | number
  name?: string;
  eng_name?: string;
  category?: string;
  subcategory?: string | null;
  imageurl?: string[] | string;
  selling_price?: string;
  mrp?: string | number;
  discount?: string;
  star_rating?: number;
  description?: string;
  color_options?: string[];
  size_options?: string[];
  seo_url?: string;
  meta_tag_title?: string;
  meta_tag_desc?: string;
  sp?: string | number;
  category_name?: string;
  images?: string[];
  colorcodes_id?: string;
  size_id?: string;
  weight_id?: string;
  quantity?: number;
  addtocart?: boolean;
  shrtdesc?: string;
  descp?: string;
  variation?: string;
  storeid?: string;
  esin?: string;
  products_id?: string;
  category_id?: string | number;
  sortorder?: number;
  city_shipping?: string;
  state_shipping?: string;
  national_shipping?: string;
  delivery_time?: string;
  status?: string;
  is_featured?: boolean;
  visibility?: string | number;
  customizable?: boolean;
  weight?: string;
  category_parent_id?: number;
  sku?: string;
  [key: string]: any;
}

export const addtowishlist = async (
  product: Product,
  productWishlistData: string[],
  setProductWishlistData: (data: string[]) => void,
  navigate: (path: string) => void
) => {
  const productId = product.id.toString(); // Convert id to string for consistency
  if (!productWishlistData.includes(productId)) {
    try {
      // Call API to add to wishlist
      const response = await axiosSetWishlist(productId, navigate);

      // Only update state and show toast if API call is successful
      if (response?.success) {
        const updatedWishlist = [...productWishlistData, productId];
        setProductWishlistData(updatedWishlist);
        toast.success('Added to wishlist!', {
          style: {
            border: '1px solid #00b852',
            padding: '16px',
            color: '#00b852',
          },
          iconTheme: {
            primary: '#00b852',
            secondary: '#FFFAEE',
          },
        });
      }
    } catch (error: any) {
      // Handle 401 or other errors
      toast.error(
        error.message === "Unauthorized: Please log in"
          ? 'Login to start saving products to your wishlist!'
          : 'Failed to add to wishlist. Please try again.',
        {
          style: {
            border: '1px solid #cc0000',
            padding: '16px',
            color: '#cc0000',
          },
        duration:2000
          
        },
      );
    }
  } else {
    try {
      // Call API to remove from wishlist
      await axiosClearWishlist(productId);

      // Update state
      const updatedWishlist = productWishlistData.filter((id) => id !== productId);
      setProductWishlistData(updatedWishlist);

      // Success toast
      toast.success('Removed from wishlist!', {
        style: {
          border: '1px solid #00b852',
          padding: '16px',
          color: '#00b852',
        },
        iconTheme: {
          primary: '#00b852',
          secondary: '#FFFAEE',
        },
      });
    } catch (error) {
      // Error toast
      toast.error('Failed to remove from wishlist. Please try again.', {
        style: {
          border: '1px solid #cc0000',
          padding: '16px',
          color: '#cc0000',
        },
        duration:2000

      });
    }
  }
};